import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const Sidebar = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"nav">): ReactElement => (
  <nav {...props} className={clsx(className, "flex h-full min-h-0 flex-col")} />
);
